import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 38 38"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "18.637",
  cy: "18.899",
  r: "18.637",
  fill: "#ACA199"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#32312F",
  d: "M21.077 26.694h-3.464v-11.49h3.342v1.613c.08-.055.139-.075.164-.116.526-.878 1.305-1.413 2.28-1.654a4.47 4.47 0 0 1 1.493-.112c.527.048 1.04.134 1.532.32a3.024 3.024 0 0 1 1.489 1.217c.326.505.504 1.072.614 1.66.13.691.164 1.39.166 2.093.006 2.131.024 4.262.038 6.394 0 .02-.004.039-.008.07H25.21v-.213c0-1.932.012-3.863-.008-5.794-.006-.524-.04-1.058-.235-1.56-.23-.594-.608-.994-1.276-1.093-.5-.073-.983-.039-1.431.16-.513.226-.824.67-.968 1.206-.091.34-.157.7-.162 1.052-.028 2.05-.034 4.1-.048 6.15 0 .026-.002.052-.004.097Zm-9.292-.006h3.452v-11.49h-3.452v11.49Zm-.291-15.27a2.029 2.029 0 0 0 2.04 2.134c1.114-.017 2.014-.857 2.043-2.01a2.027 2.027 0 0 0-2.032-2.085c-1.14-.032-2.014.897-2.051 1.962Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render() { return h(NuxtIcon, {icon: {render}}) } }